import * as _ from 'lodash';
import { StorageItem } from './storage-item.model';
import { StorageItemInterface } from './storage-item.interface';

export class StorageItemFactory {

    static empty(): StorageItem {
        return new StorageItem('', '', '', '');
    }

    static fromObject(raw: StorageItemInterface | any): StorageItem {
        if (raw.success === false) {
            throw new Error(raw.message);
        }
        return new StorageItem(
            raw.id,
            raw.name,
            raw.groupId,
            raw.groupName,
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/storage-items/shared/storage-item.factory.ts